import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ItemCategoryAdapter } from './dto/item-categories.adapter';
import { ItemCategoriesController } from './item-categories.controller';
import { ItemCategory } from './item-categories.entity';
import { ItemCategoriesService } from './item-categories.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([ItemCategory]),
  ],
  controllers: [ItemCategoriesController],
  providers: [ItemCategoriesService,ItemCategoryAdapter,ApplicationExceptionHandler,LogsService],
  exports: [ItemCategoriesService]
})
export class ItemCategoriesModule {}
